import React, { useState, useEffect, useRef } from 'react';
import { message, Icon, Tooltip, Button } from 'antd';
import { GET_USER_POSTS, GET_POST_LIKE_COUNT, GET_USER_POST_LIKES } from '../data/queries';
import { CREATE_POST_LIKE_MUTATION, DELETE_POST_LIKE_MUTATION } from '../data/mutations';
import { useMutation, useQuery } from '@apollo/react-hooks';
import pluralize from 'pluralize';

export default function LikePostButton(props) {
    const { authState, user, post } = props;
    const [likes, setLikes] = useState(props.likes || 0);
    const [addPostLike] = useMutation(CREATE_POST_LIKE_MUTATION);
    const [removePostLike] = useMutation(DELETE_POST_LIKE_MUTATION);
    const userPostLikes = useQuery(GET_USER_POST_LIKES, {
        variables: { user_id: authState && authState.user && authState.user.id, post_id: post.id },
    });
    const myPostLikes = userPostLikes && userPostLikes.data && userPostLikes.data.post_likes;

    function like() {
        addPostLike({
            variables: {
                objects: [
                    {
                        post_id: post.id,
                        user_id: authState && authState.user && authState.user.id,
                    },
                ],
            },
            notifyOnNetworkStatusChange: true,
            awaitRefetchQueries: true,
            refetchQueries: [
                // {
                //     query: GET_USER_POSTS,
                //     variables: { user_id: user.id },
                // },
                {
                    query: GET_USER_POST_LIKES,
                    variables: { post_id: post.id, user_id: authState && authState.user && authState.user.id },
                },
                {
                    query: GET_POST_LIKE_COUNT,
                    variables: { post_id: post.id },
                },
            ],
        })
            .then((res) => {
                console.log(res);
                setLikes(likes + 1);
                message.success('Post liked');
            })
            .catch((e) => {
                if (e.message && e.message.includes('Uniqueness violation')) {
                    message.error('You already liked this post.');
                } else {
                    message.error((e && e.message) || JSON.stringify(e));
                }
                console.log(e);
            });
    }

    function unlike() {
        removePostLike({
            variables: {
                post_id: post.id,
                user_id: authState && authState.user && authState.user.id,
            },
            notifyOnNetworkStatusChange: true,
            awaitRefetchQueries: true,
            refetchQueries: [
                // {
                //     query: GET_USER_POSTS,
                //     variables: { user_id: user.id },
                // },
                {
                    query: GET_USER_POST_LIKES,
                    variables: { post_id: post.id, user_id: authState && authState.user && authState.user.id },
                },
                {
                    query: GET_POST_LIKE_COUNT,
                    variables: { post_id: post.id },
                },
            ],
        })
            .then((res) => {
                console.log(res);
                setLikes(likes - 1);
                message.success('Post unliked');
            })
            .catch((error) => {
                console.log(error);
                message.info('There was an error', error);
                return error;
            });
    }

    return (
        <React.Fragment>
            <Tooltip title={myPostLikes && myPostLikes.length > 0 ? 'Unlike' : 'Like'} placement="bottom">
                <Button
                    type="text"
                    shape="circle"
                    onClick={() => {
                        myPostLikes && myPostLikes.length > 0 ? unlike() : like();
                    }}
                >
                    <Icon type="heart" theme={myPostLikes && myPostLikes.length > 0 ? 'filled' : 'outlined'} />
                </Button>
            </Tooltip>
            <span style={{ cursor: 'auto' }}>
                {likes} {pluralize('Like', likes)}
            </span>
        </React.Fragment>
    );
}
